import { Card } from '@heroui/react';
import styled from 'styled-components';

export const CardWrapper = styled(Card)`
  background-color: #fff;
`;

export const TopStatsWrapper = styled.div`
  padding:15px;
  display: flex;
  align-items: center; 
  justify-content: space-between;
  &:not(:last-of-type) {
    margin-bottom: 10px;
  }
`;

export const IcoWrapper = styled.i`
  margin-right: 16px;
  margin-top: 3px;
  width: 48px;
  height: 48px;
  min-width: 48px;
  border-radius: 8px;
  background: #e4e4e4;
  color: #060606;
  font-style: normal;
  font-size: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Count = styled.p`
    font-size: 38px;
    font-weight: bold;
    margin: 0;
    padding:0;
    line-height: 1;
`;

export const CountDescription = styled.p`
    font-size: 12px;
    color: gray;
`;

export const CountWrapper = styled.div`
   display: flex;
    flex-direction: column;
    gap: 5px;
`;

export const FooterWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 100%; 
    align-items: flex-start;
    justify-content: space-between;
`;

export const Title = styled.p`
    font-size: 16px;
    font-weight: 500;
     width: 60%;
    white-space: nowrap;  /* Prevents wrapping */
    overflow: hidden;      /* Hides overflow */
    text-overflow: ellipsis; /* Adds "..." when text overflows */
`;

export const FooterTitleWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 5px;
    width: 100%;
    height: 50px;
    align-items: center;
    justify-content: space-between;
`;
